import { wmfetch } from "@/helpers/wmfetch"; //引用fetch.js
// 获取列表
export function getList(data) {
  return wmfetch({
    url: '/api/site/scan',
    method: 'get',
    params: data
  })
}
// 获取筛选数据
export function getDistribution(data) {
  return wmfetch({
    url: '/api/webSiteScan/distribution',
    method: 'get',
    params: data
  })
}
// 获取网媒token
export function getCode(data) {
  return wmfetch({
    url: '/api/wechat',
    method: 'get',
    params: data
  })
}
